import { headCountRangeLabels } from "@/utils/ranges.util";
import { CompanyEntryDto } from "@advanced-sales-technologies/backend-client/models/CompanyEntryDto";
import { ColumnDef } from "@tanstack/react-table";
import { TFunction } from "i18next";
import { HiOutlineUsers } from "react-icons/hi2";

import BaseColumn from "@/components/molecules/table/BaseColumn";
import HeadcountRangeBadge from "@/components/molecules/table/search/badges/HeadcountRangeBadge";
import { searchColumns } from "@/components/organisms/search/searchColumns";

const headcountRangeColumn = (t: TFunction): ColumnDef<CompanyEntryDto> =>
  BaseColumn<CompanyEntryDto>({
    accessorFn: (row) => {
      const from = row.info.headcount?.range?.from || null;
      const to = row.info.headcount?.range?.to || null;

      return headCountRangeLabels(from, to);
    },
    id: searchColumns(t).headcount_range.id,
    header: () => searchColumns(t).headcount_range.name,
    cell: ({ row }) => {
      const from = row.original.info.headcount?.range?.from || null;
      const to = row.original.info.headcount?.range?.to || null;

      return <HeadcountRangeBadge from={from} to={to} />;
    },
    size: 220,
    meta: {
      heading: {
        icon: HiOutlineUsers,
      },
    },
  });

export default headcountRangeColumn;
